import React from 'react'

const SolutionPage = React.lazy(() => import('pages/Solution/SolutionPage.js'));
const SolutionAddPage = React.lazy(() => import('pages/Solution/SolutionAddPage.js'));

const SolutionRoutes = [
    {
        path: '/solution',
        exact: true,
        name: 'Danh sách giải pháp sửa chữa',
        function: 'RS_SOLUTION_VIEW',
        component: SolutionPage,
    },
    {
        path: '/solution/add',
        exact: true,
        name: 'Thêm mới giải pháp sửa chữa',
        function: 'RS_SOLUTION_ADD',
        component: SolutionAddPage,
    },
    {
        path: '/solution/edit/:id',
        exact: true,
        name: 'Chỉnh sửa',
        function: 'RS_SOLUTION_EDIT',
        component: SolutionAddPage,
    },
    {
        path: '/solution/detail/:id',
        exact: true,
        name: 'Chi tiết',
        function: 'RS_SOLUTION_VIEW',
        component: SolutionAddPage,
    },
]

export default SolutionRoutes
